module.exports = __webpack_public_path__ + "static/img/day2.94f3764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day2.jpg
// module id = KEji
// module chunks = 0